/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Components
import { Typography } from "@mui/material";

import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";

function HelpModalScreen() {
  const { t } = useTranslation(["help"]);

  return (
    <Box sx={{ overflow: "scroll", overflowX: "hidden", maxHeight: "85vh", padding: "1rem" }}>
      <Typography variant="h1" mb={2}>
        {t("erse.title")}
      </Typography>
      <hr />

      {/* --- About --- */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("erse.about.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2} sx={{ whiteSpace: "pre-line" }}>
          {t("erse.about.body")}
        </Box>
      </Typography>

      {/* --- Files --- */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("erse.files.title")}
      </Typography>

      {/* Tariffs */}
      <Typography variant="h4" mt={2} ml={4}>
        {t("erse.files.tariffs.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2} sx={{ whiteSpace: "pre-line" }}>
          {t("erse.files.tariffs.body")}{" "}
          <Link
            href="https://www.erse.pt/atividade/regulacao/tarifas-e-precos-eletricidade/"
            target="_blank"
          >
            {t("erse.links.erse_site")}
          </Link>
          .
        </Box>
      </Typography>

      {/* Losses */}
      <Typography variant="h4" mt={2} ml={4}>
        {t("erse.files.losses.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2} sx={{ whiteSpace: "pre-line" }}>
          {t("erse.files.losses.body")}{" "}
          <Link
            href="https://mercado.ren.pt/PT/Electr/Explora%C3%A7%C3%A3odosistema/Consumo/Paginas/PerfisPerdas.aspx"
            target="_blank"
          >
            {t("erse.links.ren_site")}
          </Link>{" "}
          e{" "}
          <Link href="https://www.e-redes.pt/pt-pt/perfis-de-perdas" target="_blank">
            {t("erse.links.eredes_site")}
          </Link>
          .
        </Box>
      </Typography>
    </Box>
  );
}

export default HelpModalScreen;
